<template>
    <Breadcrumbs main="Widgets" title="General" />
    <div class="container-fluid">
        <div class="row">
            <currencyWidget1 />
            <currencyWidget2 />
            <currencyWidget3 />
            <salesPer />
            <profitPer />
            <widgetCard />
            <courseWidget />
            <totalUsers />
            <visitorChart />
            <radialFacebook />
            <radialTwitter />
            <radialInstagram />
            <radialYoutube />
            <smallWidget />
            <balanceProfile />
            <calenderView />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const currencyWidget1 = defineAsyncComponent(() => import("@/components/theme/widgets/general/currencyWidget1.vue"))
const currencyWidget2 = defineAsyncComponent(() => import("@/components/theme/widgets/general/currencyWidget2.vue"))
const currencyWidget3 = defineAsyncComponent(() => import("@/components/theme/widgets/general/currencyWidget3.vue"))
const salesPer = defineAsyncComponent(() => import("@/components/theme/widgets/general/salesPer.vue"))
const profitPer = defineAsyncComponent(() => import("@/components/theme/widgets/general/profitPer.vue"))
const widgetCard = defineAsyncComponent(() => import("@/components/theme/widgets/general/widgetCard.vue"))
const courseWidget = defineAsyncComponent(() => import("@/components/theme/widgets/general/courseWidget.vue"))
const totalUsers = defineAsyncComponent(() => import("@/components/theme/widgets/general/totalUsers.vue"))
const visitorChart = defineAsyncComponent(() => import("@/components/theme/widgets/general/visitorChart.vue"))
const radialFacebook = defineAsyncComponent(() => import("@/components/theme/widgets/general/radialFacebook.vue"))
const radialTwitter = defineAsyncComponent(() => import("@/components/theme/widgets/general/radialTwitter.vue"))
const radialInstagram = defineAsyncComponent(() => import("@/components/theme/widgets/general/radialInstagram.vue"))
const radialYoutube = defineAsyncComponent(() => import("@/components/theme/widgets/general/radialYoutube.vue"))
const smallWidget = defineAsyncComponent(() => import("@/components/theme/widgets/general/smallWidget.vue"))
const balanceProfile = defineAsyncComponent(() => import("@/components/theme/widgets/general/balanceProfile.vue"))
const calenderView = defineAsyncComponent(() => import("@/components/theme/widgets/general/calenderView.vue"))
</script>